import type { Dispatch, SetStateAction } from 'react';
import type { OperatingSchedule, WorldDraft } from '../../domain/types.js';
import { applyCorrectedLocationRegion, applyResolvedLocationTimezone } from './draftReducer.js';

export interface LocationTimezoneWizardCallbacks {
  onLocationCorrected: (region: string) => void;
  onScheduleUpdated: (schedule: OperatingSchedule) => void;
}

export function bindLocationTimezoneCallbacks(
  setDraft: Dispatch<SetStateAction<WorldDraft>>,
): LocationTimezoneWizardCallbacks {
  return {
    onLocationCorrected: (region) => setDraft((d) => applyCorrectedLocationRegion(d, region)),
    onScheduleUpdated: (schedule) => setDraft((d) => applyResolvedLocationTimezone(d, schedule)),
  };
}
